/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportResponseDTO
 */
export interface ReportResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof ReportResponseDTO
     */
    base64?: string | null;
}

/**
 * Check if a given object implements the ReportResponseDTO interface.
 */
export function instanceOfReportResponseDTO(value: object): value is ReportResponseDTO {
    return true;
}

export function ReportResponseDTOFromJSON(json: any): ReportResponseDTO {
    return ReportResponseDTOFromJSONTyped(json, false);
}

export function ReportResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'base64': json['base64'] == null ? undefined : json['base64'],
    };
}

export function ReportResponseDTOToJSON(json: any): ReportResponseDTO {
    return ReportResponseDTOToJSONTyped(json, false);
}

export function ReportResponseDTOToJSONTyped(value?: ReportResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base64': value['base64'],
    };
}

